module.exports = __webpack_public_path__ + "img/8.790cb0ad.png";